import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { injectable } from 'tsyringe';
import { fetchShippingSetting, fetchSiteFeatures } from '@gn-audio/core/api/site-settings';
import { placeholders } from '@gn-audio/core/common/helpers';
import { BasketPlugin } from '../../models';
import './basket-shipping-message.plugin.scss';
import template from './basket-shipping-message.plugin.html';
var BasketShippingMessagePlugin = /** @class */ (function (_super) {
    __extends(BasketShippingMessagePlugin, _super);
    function BasketShippingMessagePlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.shippingThresholds = [];
        _this.reactOnChanges = function (state) {
            var product_total = state.product_total;
            var message = '';
            for (var _i = 0, _a = _this.shippingThresholds; _i < _a.length; _i++) {
                var shippingThreshold = _a[_i];
                if (product_total < shippingThreshold.Threshold) {
                    continue;
                }
                message = shippingThreshold.Message;
                break;
            }
            if (!!message) {
                _this.element.classList.add("visible" /* CssClass.Visible */);
                _this.element.innerHTML = placeholders(template, { message: message }, _this.translations);
            }
            else {
                _this.element.classList.remove("visible" /* CssClass.Visible */);
                _this.element.innerHTML = '';
            }
        };
        return _this;
    }
    BasketShippingMessagePlugin.prototype.register = function (_a) {
        var eventBus = _a.eventBus, state = _a.state, translations = _a.translations;
        return __awaiter(this, void 0, void 0, function () {
            var shippingSetting;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.eventBus = eventBus;
                        this.translations = translations;
                        return [4 /*yield*/, fetchShippingSetting()];
                    case 1:
                        shippingSetting = _b.sent();
                        // Should do nothing in case shipping setting is absent for current market locale.
                        if (!shippingSetting) {
                            console.warn('No shipping setting exists for current market.');
                            return [2 /*return*/];
                        }
                        // Sort descending by threshold property value (high -> low)
                        this.shippingThresholds = shippingSetting.thresholds
                            .sort(function (x, y) { return (y.Threshold - x.Threshold); });
                        this.createUI();
                        this.eventBus.subscribe("basket-updated" /* BasketEvent.BasketUpdated */, this.reactOnChanges);
                        this.reactOnChanges(state);
                        return [2 /*return*/];
                }
            });
        });
    };
    BasketShippingMessagePlugin.prototype.shouldRegister = function () {
        return __awaiter(this, void 0, void 0, function () {
            var featureToggles;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchSiteFeatures(["SfccBasketShippingMessage" /* SiteFeature.SfccBasketShippingMessage */])];
                    case 1:
                        featureToggles = _a.sent();
                        return [2 /*return*/, featureToggles.length > 0 && !!featureToggles[0].value];
                }
            });
        });
    };
    BasketShippingMessagePlugin.prototype.unregister = function () {
        this.element.remove();
        this.eventBus.unsubscribe("basket-updated" /* BasketEvent.BasketUpdated */, this.reactOnChanges);
    };
    BasketShippingMessagePlugin.prototype.createUI = function () {
        var target = document.querySelector(".basket-ui__content" /* BasketUIElementSelector.BasketContent */);
        this.element = document.createElement('div');
        this.element.innerHTML = placeholders(template, {});
        this.element.classList.add('basket-shipping-message');
        target.insertAdjacentElement('beforebegin', this.element);
    };
    BasketShippingMessagePlugin = __decorate([
        injectable()
    ], BasketShippingMessagePlugin);
    return BasketShippingMessagePlugin;
}(BasketPlugin));
export { BasketShippingMessagePlugin };
